const createOptionValue = (hours, minutes, baseDate = new Date(), hourFormat = 'numeric') => {
  const ms = new Date(baseDate.valueOf()).setHours(hours, minutes, 0, 0);
  const value = new Date(ms);
  return {
    label: value.toLocaleString('en-US', {
      hour: hourFormat,
      hour12: true,
      minute: 'numeric'
    }),
    value
  };
};
const createTimePickerOptions = (startHour, endHour, baseDate = new Date(), hourFormat = 'numeric') => {
  const options = [];
  for (let i = startHour; i < endHour; i += 1) {
    options.push(Object.assign({}, createOptionValue(i, 0, baseDate, hourFormat)));
    options.push(Object.assign({}, createOptionValue(i, 30, baseDate, hourFormat)));
  }
  return options;
};

export { createTimePickerOptions as default };
//# sourceMappingURL=createTimePickerOptions.js.map
